import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Store} from '@ngrx/store';
import {LoadUser, SavingUser} from '../../state/user.actions';
import {ToastyConfig} from 'ng2-toasty';
import {filter, take} from 'rxjs/operators';
import {Observable, of, Subscription} from 'rxjs';
import {AppState} from '../../../app.store';
import {UserService} from '../../services';
import {ActivatedRoute} from '@angular/router';
import {FullUser} from '../../model';
import {SharedToastService} from '../../../shared/shared/toast.service';


@Component({
  selector: 'app-settings',
  templateUrl: './user-edit-container.component.html',
  styleUrls: ['./user-edit-container.component.scss']
})
export class UserEditContainerComponent implements OnInit, OnDestroy {

  currentUser: Observable<FullUser> = of({displayName: ''});
  settingGroup: FormGroup;

  private file: File;

  private errorSub: Subscription;
  private userValue: FullUser;

  constructor(private fb: FormBuilder, private store: Store<AppState>,
              private toastyConfig: ToastyConfig,
              private toastService: SharedToastService,
              private route: ActivatedRoute) {
    this.toastyConfig.theme = 'bootstrap';

  }

  ngOnInit() {
    this.settingGroup = this.fb.group({
      firstName: [''],
      lastName: [''],
      shortDescription: [''],
      longDescription: [''],
      expertise: [],
      notifications: []
    });

    const userId = this.route.snapshot.params.userId;
    console.log('user id is ', userId);
    this.store.dispatch(new LoadUser(userId));
    this.currentUser = this.store.select( state => state.user.users[userId]);
    this.currentUser.pipe(
      filter(user => !!user),
      take(1)).subscribe(user => {
        this.settingGroup.patchValue(user);
        this.userValue = user;
    });

    this.errorSub = this.store.select(state => state.user.saveError)
      .pipe(
        filter((error: string) => error !== null && error.length !== 0))
      .subscribe((error) => {
        this.toastService.error({msg: error, title: 'Error'});
      });

  }

  ngOnDestroy() {
    this.errorSub.unsubscribe();
  }

  submit() {
    const u = Object.assign({}, this.userValue, this.settingGroup.value);
    this.store.dispatch(new SavingUser({user: u, file: this.file}));
  }

  fileChanged(file: File) {
    this.file = file;
  }
}
